<template>
  <div>
    <el-dialog :destroy-on-close="true"
               :title=imgDetail.label
               :visible.sync="showDialog"
               :before-close="handleCancel"
               class="approvalReportDialog"
               width="750px">
    <el-upload
        class="noUpload"
        action="#"
        list-type="picture-card"
        :file-list="fileList"
        :auto-upload="false">
      <i slot="default" class="el-icon-plus"></i>
      <div slot="file" slot-scope="{file}">
        <div v-loading="!file.url" element-loading-text="加载中，请稍后">
          <img
              class="el-upload-list__item-thumbnail"
              :src="file.url" alt="">
        </div>
        <span class="el-upload-list__item-actions">
        <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)">
          <i class="el-icon-zoom-in"></i>
        </span>
      </span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible"  width="85%" append-to-body>
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name:'ShowMyImg',
  props:{
    showDialog:{
      default:false
    },
    imgDetail:{
      defaults:null
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      fileList:[]
    }
  },
  watch: {
    imgDetail: {
      handler(val) {
        if (val) {
          this.fileList = [
            {
              uid: '-1',
              name: 'image.png',
              status: 'done',
              url: val.imgPath||'',
            },
          ]
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleCancel(){
      this.$emit('update:showDialog')
    }
  }
}
</script>
<style scoped>
::v-deep .noUpload .el-upload--picture-card {
  width: 0px!important;
  height: 0px!important;
  display: none !important;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item{
  width: 100%;
  border: 0px!important;
  height: 100%!important;
}
</style>
